<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>Faculty Research Committee</h3></header>
            <img src="assets/img/research_committee.jpg">
            <hr>
            <p>
              The Faculty of Humanities and Social Sciences is highly committed to enhancing research in the broad
              disciplines of Humanities and Social Sciences. The faculty has been constantly engaged in many activities
              to formulate a research community, enrich the research culture, and encourage academics to engage in high
              quality research by maintaining the highest ethical standards. In this context, the faculty research
              committee is set up to provide guidance to researchers and investigate all matters pertaining to the
              research activities of the faculty. In a broader perspective, the research committee promotes research as
              a doorway to knowledge and a vital ingredient for the development of the country.
            </p>
            <hr>
            <h4>Objectives</h4>
            <ul class="element-framed">
              <li>To evaluate and make recommendations on the research proposals submitted to the Faculty Research
                Grants.
              </li>
              <li>To constantly monitor the progress of the research conducted by academics using the Faculty Research
                Grants.
              </li>
              <li>To evaluate and recommend the applications for Research and Development Allowance (R&D) submitted by
                the academics of the faculty.
              </li>
              <li>To evaluate and provide recommendations on the applications submitted for travel grants and
                publication fees and provide guidance to researchers on other research related activities
              </li>
              <li>To facilitate academic staff members with resources and provide platforms to discuss research related
                issues.
              </li>
              <li>To ensure that researchers adhere to the highest ethical standards and the highest standards of
                quality.
              </li>
              <li>To create an atmosphere to achieve excellence in research.</li>
              <li>To determine faculty development priorities related to research and provide suggestions regarding
                these priorities.
              </li>
              <li>To make recommendations to the Faculty Research and Publication Center (FRPC) on the enhancement of
                research culture through research related activities such as increasing the visibility of research of
                the faculty staff members, research proposal and article writing, publishing in scientific journals,
                etc.
              </li>
              <li>To provide appropriate suggestions and introduce policies to encourage faculty members to conduct
                regionally and nationally important research.
              </li>
            </ul>
            <hr>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br>
          <aside id="our-professors">
            <header>
              <h5>Committee Members</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <b>Chairperson</b>
                    <figure class="professor-description">Dr. S.G.S. Samaraweera
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Convener</b>
                    <figure class="professor-description">Dr. G. C. L. Gamage</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Members</b>
                    <figure class="professor-description">
                      Prof. Upali. Pannilage<br><br>
                      Mr. H.K. Sarath<br><br>
                      Mr. P.N. Rathnayaka<br><br>
                      Prof. S.l.J. Fernando<br><br>
                      Mr. E.H.M. Heenbanda<br><br>
                      Mr. I.R. Priyantha<br><br>
                      Dr. D.P.P.G.Liyanage<br><br>
                      Dr. A.M.A.S. Gunaseakara<br><br>
                      Senior Prof. J. Amarasinghe<br><br>
                      Senior Prof. D. Rajapaksha<br><br>
                      Prof. G. P. T. S. Hemakumara<br><br>
                      Prof. Rev. B. Dhammajoti<br><br>
                      Prof. Rev. U. Mahinda<br><br>
                      Prof. H.I.G.C Kumara<br><br>
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
